import { useState, useEffect } from "react";
import { getAssinatura, saveAssinatura } from "../services/saveAssinatura";

export const useAssinatura = () => {
  const [assinatura, setAssinatura] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  const carregarAssinatura = async () => {
    try {
      setLoading(true);
      const assinaturaUrl = await getAssinatura();
      setAssinatura(assinaturaUrl);
    } catch (error) {
      console.error("Erro ao carregar assinatura:", error);
      setAssinatura(null);
    } finally {
      setLoading(false);
    }
  };

  const salvarAssinatura = async (dataUrl: string) => {
    try {
      await saveAssinatura(dataUrl);
      await carregarAssinatura(); 
      return true;
    } catch (error) {
      console.error("Erro ao salvar assinatura:", error);
      return false;
    }
  };

  useEffect(() => {
    carregarAssinatura();
  }, []);

  return { assinatura, loading, carregarAssinatura, salvarAssinatura };
};